'use strict';

import errorNotice from './../error';
import dataHandler from './../data-handler';
import { changeDates } from './../helpers';
import moment from 'moment';
import ages from './ages';
import agesPerDay from './ages-per-day';
import agesPercentage from './age-percentage-day';

const mainCharts = (function() {
    let dateElems = null;

    function setChartFirstDays(data) {
        const dataFirstDate = moment(data.ages[0].days[0].date);
        const ageChartFirstDay = dataHandler.setFirstDayValues(data.ages, dataFirstDate);
        window.config.firstDayValues['ages'] = ageChartFirstDay;

        return ageChartFirstDay;
    }

    function init(data) {
        dateElems = document.querySelectorAll('.js-date-ages');

        if (typeof data.ages !== 'undefined' && data.ages.length) {
            // Set first day values
            const ageChartFirstDay = setChartFirstDays(data);

            dataHandler.setAgeDataPerDay(data);

            // Update chart date elems
            changeDates(ageChartFirstDay, dateElems);

            // Init age charts & table
            ages.init(data);
            agesPerDay.init(data);
            agesPercentage.init(data);
        } else {
            const error = 'Ongelma THL rajapinnassa, dataa ikäryhmistä ei saatavilla.';
            errorNotice.showDataError(error);
        }
    }

    function reload(data, page) {
        const reloadCharts = [];

        if (page.classList.contains('reload-date')) {
            // Update first day values
            const ageChartFirstDay = setChartFirstDays(data);
            changeDates(ageChartFirstDay, dateElems);

            dataHandler.setAgeDataPerDay(data);

            if (reloadCharts.indexOf('ages') === -1) {
                reloadCharts.push('ages');
            }
            if (reloadCharts.indexOf('ages-per-day') === -1) {
                reloadCharts.push('ages-per-day');
            }
            if (reloadCharts.indexOf('ages-percentage') === -1) {
                reloadCharts.push('ages-percentage');
            }
            page.classList.remove('reload-date');
        }

        // Reload charts
        for (let chartType of reloadCharts) {
            if (chartType === 'ages') {
                ages.reload(data);
            }
            if (chartType === 'ages-per-day') {
                agesPerDay.reload(data);
            }
            if (chartType === 'ages-percentage') {
                agesPercentage.reload(data);
            }
        }

        page.classList.remove('reload');
    }

    return {
        init,
        reload
    }
})();

export default mainCharts;
